
// Utility function to validate UUID format
export const isValidUUID = (uuid: string | null | undefined): boolean => {
  if (!uuid || typeof uuid !== 'string') return false;

  // Standard format: 8-4-4-4-12 hexadecimal digits
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(uuid.trim());
};

export const sanitizeUserId = (userId: string | null | undefined): string | null => {
  if (!userId || typeof userId !== 'string') return null;
  const trimmed = userId.trim();
  return isValidUUID(trimmed) ? trimmed : null;
};

// Debug function to test a specific UUID
export const debugSpecificUUID = (uuid: string) => {
  return {
    isValid: isValidUUID(uuid),
    sanitized: sanitizeUserId(uuid),
  };
};
